/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Linkify from 'react-linkify';

class Localized extends React.Component {

  render() {
    const { defaultLocalizations, localizations, modelName, modelKey, modelAttribute, plural, missingTranslations, className, hasLinks } = this.props;
    let localizedText = getTranslation(localizations, modelName, modelKey, modelAttribute);

    //checks if something was found, otherwise handles the missing translation scenario
    if(!localizedText) {
      /*
       * At this point we know translation was not found for the passed set of keys
       * So we now check if missingTranslations callback prop was passed in, then calls it
       */
      if(missingTranslations) missingTranslations();
      //continues the flow to handle the missing translation scenario
      localizedText = handleMissingTranslation(defaultLocalizations, modelName, modelKey, modelAttribute);
    }

    // if(plural) localizedText = pluralize(localizedText);  //pluralize is not defined

    if(!hasLinks) {
      return (
        <span className={className}>
          {localizedText}
        </span>
      )
    } else {
      return (
        <Linkify properties={{ target: '_blank' }}>
          <span className={className}>
            {localizedText}
          </span>
        </Linkify>
      )
    }  
  }
}

/*
 * returns the localized text for the language in use
 */
function getTranslation(localizations, modelName, modelKey, modelAttribute) {
  let localizationObject = _.find(localizations, { 'modelName': modelName, 'modelKey': modelKey, 'modelAttribute': modelAttribute });

  //if translation was found for the set of keys, returns its text
  if(localizationObject) return localizationObject.text;

  //no translation found, returns nothing
  return;
}

/*
 * handles the scenario where there is no translation for that particular language
 * using a default language, either chosen via DEFAULT_LOCALE env variable
 * or defaults to English if variable is not set
 */
function handleMissingTranslation(defaultLocalizations, modelName, modelKey, modelAttribute) {
  //default localizations not properly loaded (prob env var issue) returns modelKey;
  if (!defaultLocalizations) return modelKey;

  //retrieves the translation for the default language
  let localizationObjectInDefaultLanguage = _.find(defaultLocalizations, { 'modelName': modelName, 'modelKey': modelKey, 'modelAttribute': modelAttribute });

  //if default language translation is found, returns it
  if (localizationObjectInDefaultLanguage) return localizationObjectInDefaultLanguage.text;

  //element does not have any localization data, using the modelKey value to be displayed instead.
  return modelKey;
}

Localized.propTypes = {
  modelName: PropTypes.string,
  modelKey: PropTypes.string,
  modelAttribute: PropTypes.string,
  missingTranslations: PropTypes.func,
  className: PropTypes.string,
  hasLinks: PropTypes.bool,
}

export default connect(
  (state) => ({
    localizations: state.requests.localizations.value,
    defaultLocalizations: state.requests.defaultLocalizations.value
  })
)(Localized);
